import { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { T } from "../../constants/theme";

export default function AdminProfilePage() {
  const { user } = useContext(AuthContext);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: T.paper,
        padding: "40px 16px",
        fontFamily: "system-ui, sans-serif",
      }}
    >
      {/* HERO HEADER */}
      <div
        style={{
          maxWidth: 1000,
          margin: "0 auto 24px",
          padding: "32px",
          borderRadius: 20,
          background: `linear-gradient(135deg, ${T.paper}, ${T.surface})`,
          color: T.ink,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          boxShadow: T.shadowMedium,
        }}
      >
        <div>
          <h1 style={{ margin: 0, fontSize: 28 }}>
             Admin Dashboard
          </h1>
          <p style={{ margin: "8px 0 0", color: T.inkSoft }}>
            Manage your store, products, and customer experience
          </p>
        </div>

        <div
          style={{
            padding: "8px 14px",
            borderRadius: 999,
            background: T.border,
            border: `1px solid ${T.border}`,
            fontSize: 13,
          }}
        >
          SYSTEM ADMIN
        </div>
      </div>

      {/* MAIN GRID */}
      <div
        style={{
          maxWidth: 1000,
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "320px 1fr",
          gap: 24,
        }}
      >
        {/* LEFT PANEL */}
        <div
          style={{
            background: T.surface,
            borderRadius: 20,
            padding: 24,
            border: `1px solid ${T.border}`,
            boxShadow: T.shadowMedium,
            textAlign: "center",
          }}
        >
          {/* Avatar */}
          <div
            style={{
              width: 90,
              height: 90,
              borderRadius: "50%",
              margin: "0 auto 16px",
              background: `linear-gradient(135deg, ${T.gold}, ${T.goldHover})`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: T.white,
              fontSize: 28,
              fontWeight: "bold",
            }}
          >
            {(user?.first_name?.[0] || "A")}
            {(user?.last_name?.[0] || "")}
          </div>

          <h2 style={{ margin: 0, color: T.ink }}>
            {user?.first_name || "Admin"} {user?.last_name || ""}
          </h2>

          <p style={{ color: T.muted, marginTop: 6 }}>
            {user?.email || "admin@store.com"}
          </p>

          <div
            style={{
              marginTop: 12,
              display: "inline-block",
              padding: "6px 12px",
              borderRadius: 999,
              background: T.paper,
              color: T.ink,
              fontSize: 12,
              letterSpacing: 1,
            }}
          >
            ADMINISTRATOR
          </div>

          {/* Stats */}
          <div
            style={{
              marginTop: 24,
              display: "grid",
              gap: 12,
              textAlign: "left",
            }}
          >
            {statBox("Access Level", "Full Control")}
            {statBox("Security", "2FA Enabled")}
            {statBox("Status", "Active", T.gold)}
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div
          style={{
            background: T.surface,
            borderRadius: 20,
            padding: 28,
            border: `1px solid ${T.border}`,
            boxShadow: T.shadowMedium,
          }}
        >
          <h3 style={{ marginTop: 0, color: T.ink }}>Account Details</h3>

          {detailRow("First Name", user?.first_name)}
          {detailRow("Last Name", user?.last_name)}
          {detailRow("Email Address", user?.email)}
          {detailRow("Role", "Administrator")}
          {detailRow("Member Since", "2026")}

          <div
            style={{
              marginTop: 30,
              display: "flex",
              gap: 12,
            }}
          >
            <button style={primaryBtn()}>Edit Profile</button>
            <button style={secondaryBtn()}>Security Settings</button>
          </div>
        </div>
      </div>
    </div>
  );
}

/* FIXED HELPERS */

function statBox(label, value, valueColor = T.ink) {
  return (
    <div
      style={{
        padding: 12,
        borderRadius: 12,
        border: `1px solid ${T.border}`,
        background: T.paper,
        display: "flex",
        justifyContent: "space-between",
        fontSize: 13,
      }}
    >
      <span style={{ color: T.muted }}>{label}</span>
      <strong style={{ color: valueColor }}>{value}</strong>
    </div>
  );
}

function detailRow(label, value) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "12px 0",
        borderBottom: `1px solid ${T.border}`,
      }}
    >
      <span style={{ color: T.muted }}>{label}</span>
      <strong style={{ color: T.ink }}>{value || "-"}</strong>
    </div>
  );
}

function primaryBtn() {
  return {
    padding: "10px 16px",
    borderRadius: 10,
    border: "none",
    background: T.paper,
    color: T.ink,
    cursor: "pointer",
    fontWeight: 600,
  };
}

function secondaryBtn() {
  return {
    padding: "10px 16px",
    borderRadius: 10,
    border: `1px solid ${T.border}`,
    background: T.surface,
    color: T.ink,
    cursor: "pointer",
    fontWeight: 600,
  };
}
